import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PrudentialLogin = () => {
  const navigate = useNavigate();
  const [email, setemail] = useState('');
  const [password, setpassword] = useState('');
  const [error, seterror] = useState('');
  const [loading, setloading] = useState(false);

  const handlesubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    seterror('');
    setloading(true);
    const body = JSON.stringify({
      email,
      password,
      adminuserid: window.APPSETTING.adminuserid,
      appname: window.APPSETTING.appname,
    });
    try {
      let response = await fetch('/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
      });
      let data = await response.json();

      if (!response.ok) {
        if (response.status == 400) {
          response = await fetch('/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: body,
          });
          data = await response.json();
          if (!response.ok) {
            throw new Error(data.error || 'Login failed');
          }
        } else {
          throw new Error(data.error || 'Signup failed');
        }
      }

      window.APPUSER = data;
      localStorage.setItem(window.APPSETTING.appname + "user", JSON.stringify(data));
      navigate('/dashboard');
    } catch (err: any) {
      seterror(err.message);
    } finally {
      setloading(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <h2>Prudential Auditing</h2>
        <p className="login-sub">Sign in to review client expenses</p>

        {error && <div className="form-error">{error}</div>}

        <form onSubmit={handlesubmit}>
          <div className="fg">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setemail(e.target.value)}
              placeholder="name@firm.com"
              required
            />
          </div>
          <div className="fg">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setpassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          <button type="submit" className="btn-primary full-width" disabled={loading}>
            {loading ? 'Signing in…' : 'Proceed'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PrudentialLogin;
